import { sendAppMessage, MobileAppBus } from '@helpers/mobileApp';
import { useCheckPaymentsMutation } from '@http';
import { IconCrown } from '@tabler/icons-react';
import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';
import { useEffect } from 'react';

export function Premium() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Settings' });
  const { mutateAsync } = useCheckPaymentsMutation();
  const { id, userData, refetch, setIsFetching } = useAppStore();

  const onCheckSubscription = async () => {
    setIsFetching(true);
    await mutateAsync();
    refetch();
  };

  useEffect(() => {
    MobileAppBus.addEventListener('checkSubscription', onCheckSubscription);
    return () => MobileAppBus.removeEventListener('checkSubscription', onCheckSubscription);
  });

  const hasPremium = userData.premiumUntil
    && new Date(userData.premiumUntil) >= new Date();

  const onClick = () => {
    if (hasPremium) return;
    sendAppMessage('showPaywall', id);
  };

  return (
    <Button className="btn-active" onClick={onClick} glitch>
      <div className="w-full flex items-center justify-center pt-1">
        <IconCrown className="mr-2" />
        <p>{t(hasPremium ? 'premiumActive' : 'goPremium')}</p>
      </div>
    </Button>
  );
}